import AddIcon from "@mui/icons-material/Add";
import getColumns from "./column.js";
import DynamicTable from "../../../components/common/DynamicTable.jsx";
import useModal from "../../../hooks/useModal.js";
import useAuthUser from "../../../hooks/useAuthUser.js";
import { getMonthlyParityList } from "../../../services/monthlyParity.js";
import RunMonthlyParity from "./RunMonthlyParity.jsx";
import MonthlyParityDetail from "./MonthlyParityDetail.jsx";
import usePaginatedList from "../../../hooks/usePaginatedList.js";

const MonthlyParityList = () => {
  const { isAdminHrRole } = useAuthUser();
  const { showModal } = useModal();

  const fetchData = async (params) => {
    return await getMonthlyParityList(params.page, params);
  };

  const { data, pagination, setPage, setItemsPerPage, refresh } = usePaginatedList(fetchData);

  const handleRun = () => {
    showModal("Run Monthly Parity Check", <RunMonthlyParity refresh={refresh} />, "md");
  };

  const handleView = (row) => {
    showModal("Monthly Parity - Node vs CI4", <MonthlyParityDetail recordId={row.id} />, "lg");
  };

  return (
    <>
      <div className="bg-light mb-2">
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div className="d-flex align-items-center gap-2">
              <label className="mb-0 text-muted small">Show</label>
              <select
                className="form-select form-select-sm"
                style={{ width: "80px" }}
                value={pagination?.itemsPerPage || 20}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span className="text-muted small">entries</span>
            </div>

            {isAdminHrRole && (
              <button className="btn btn-success btn-sm d-flex align-items-center" onClick={handleRun}>
                <AddIcon sx={{ fontSize: 18 }} className="me-1" />
                <span className="d-none d-sm-inline">Run Parity Check</span>
              </button>
            )}
          </div>

          <div className="form-text mt-2">
            Diagnostic tool only (Phase 4) - compares Node's computed monthly payroll against CI4's real payslip
            for validation. Not part of any live payroll workflow; nothing here touches CI4's payroll.
          </div>
        </div>
      </div>

      <DynamicTable
        columns={getColumns(handleView)}
        data={data}
        rowKey="id"
        currentPage={pagination?.currentPage}
        totalPages={pagination?.totalPages}
        itemsPerPage={pagination?.itemsPerPage}
        totalItems={pagination?.totalItems}
        onPageChange={(page) => setPage(page)}
      />
    </>
  );
};

export default MonthlyParityList;
